import { IIssue } from '@common/interfaces/issue';
import { addMinutes, differenceInCalendarDays, differenceInMinutes, format, formatISO, roundToNearestMinutes } from 'date-fns';

export class IssueUtil {
  static isNearDueDate(issue: IIssue) {
    if (!issue.dueDate) return false;
    const today = new Date();
    const dueDate = new Date(issue.dueDate);
    return (today.getTime() - dueDate.getTime()) > -432000000 // 5 giorni
  }
  /* static getIssueTypeIcon(issueTypeId: ID): string {
    return issueTypeId;
  } */

  static getRandomId(): string {
    return `${Math.ceil(Math.random() * 8000)}`;
  }

  static searchString(str: string, searchString: string): boolean {
    str = str ?? '';
    searchString = searchString ?? '';
    return str.trim().toLowerCase().includes(searchString.trim().toLowerCase());
  }

  static calcCurrentAgeing(issue: IIssue): number {
    const showDifference = !issue.ageing || !issue.ageing.checkpoint || issue.ageing.state !== 'finished';
    return showDifference ? differenceInCalendarDays(new Date(), new Date(issue.createdAt)) : 
      Math.floor(((issue.ageing.totalActive + issue.ageing.totalInactive + issue.ageing.totalFinished)/60)/24);

    /*
    ToDo - la vecchia logica è stata solo commentata in attesa di un riscontro definitivo sulla modalita' di calcolo
    
    const partialAgeing = issue.ageing.totalActive + issue.ageing.totalInactive;
    if (issue.ageing.state === 'finished') { 
      return partialAgeing;
    }
    
    const daysFromLastCheckpoint = differenceInCalendarDays(new Date(), new Date(issue.sla.date));
    return daysFromLastCheckpoint + partialAgeing; 
    */
  }

  static calcDueDate(issue: IIssue, isFinishedActive?: boolean) {
    if (!issue?.sla || ['active', 'finished'].includes(issue.ageing.state)) {
      return issue.dueDate;
    }
    const totalInactive = issue.ageing.totalInactive + (!isFinishedActive ? issue.ageing.totalFinished : 0)
    const difference = differenceInMinutes(new Date(), new Date(issue.ageing.checkpoint || issue.createdAt));
    const dueDate = addMinutes(new Date(issue.createdAt), (issue.sla.value * 60) + totalInactive + difference);
    const roundedDueDate = roundToNearestMinutes(dueDate, { nearestTo: 15 });
    return formatISO(roundedDueDate, { representation: 'complete' });
  }
}
